// @ts-nocheck
import { useState } from 'react'
import { CONTACT_SUBJECTS, PUBLIC_LANGS, PUBLIC_UI, setPreferredLanguage } from './public-data'

export const ContactModal = ({ open, onClose, lang }) => {
  const ui = PUBLIC_UI[lang] || PUBLIC_UI.EN
  const subjectOptions = CONTACT_SUBJECTS[lang] || CONTACT_SUBJECTS.EN
  const [form, setForm] = useState({ name: '', email: '', subject: subjectOptions[0], message: '' })
  const [sent, setSent] = useState(false)
  if (!open) return null
  const valid = form.name.trim() && /.+@.+\..+/.test(form.email) && form.message.trim().length >= 10
  const submit = (event) => {
    event.preventDefault()
    if (!valid) return
    console.log('BookBuilderGo contact form', form)
    setSent(true)
  }
  return (
    <div className="bbg-modal-backdrop" onClick={onClose}>
      <div className="bbg-modal-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={ui.contact}>
        <button className="bbg-modal-close" onClick={onClose} aria-label={ui.close || ui.contact}>×</button>
        {sent ? (
          <div style={{ textAlign: 'center', padding: '28px 0' }}>
            <div className="bbg-label bbg-label-gold">{ui.messageSent}</div>
            <h2>{ui.thankYou}</h2>
            <p>{ui.contactSuccess}</p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="bbg-label bbg-label-gold">{ui.contact}</div>
            <h2>{ui.sendMessage}</h2>
            <div className="bbg-form-grid">
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder={ui.fullName} aria-label={ui.fullName} />
              <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder={ui.email} aria-label={ui.email} />
              <select value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} aria-label={ui.subject}>
                {subjectOptions.map((item) => <option key={item}>{item}</option>)}
              </select>
              <textarea required minLength={10} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder={ui.message} aria-label={ui.message} rows={5} />
            </div>
            <button className="bbg-btn bbg-btn-primary" disabled={!valid} style={{ width: '100%', marginTop: 16 }}>{ui.send}</button>
          </form>
        )}
      </div>
    </div>
  )
}

export const LanguageModal = ({ open, onClose, lang, setLang }) => {
  const ui = PUBLIC_UI[lang] || PUBLIC_UI.EN
  return open ? (
    <div className="bbg-modal-backdrop" onClick={onClose}>
      <div className="bbg-modal-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={ui.chooseLanguage}>
        <button className="bbg-modal-close" onClick={onClose} aria-label={ui.close || ui.chooseLanguage}>×</button>
        <div className="bbg-label bbg-label-gold">{ui.languageLabel}</div>
        <h2>{ui.chooseLanguage}</h2>
        <div className="bbg-language-grid">
          {PUBLIC_LANGS.map((item) => (
            <button key={item.code} className={item.code === lang ? 'active' : ''} onClick={() => { setPreferredLanguage(item.code, setLang); onClose() }}>
              <span>{item.flag}</span><strong>{item.name}</strong><small>{item.label}</small>
            </button>
          ))}
        </div>
      </div>
    </div>
  ) : null
}

export const HelpCenterModal = ({ open, onClose, lang }) => {
  const ui = PUBLIC_UI[lang] || PUBLIC_UI.EN
  return open ? (
    <div className="bbg-modal-backdrop" onClick={onClose}>
      <div className="bbg-modal-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={ui.helpCenter}>
        <button className="bbg-modal-close" onClick={onClose} aria-label={ui.close || ui.helpCenter}>×</button>
        <div className="bbg-label bbg-label-gold">{ui.helpCenter}</div>
        <h2>{ui.coach}</h2>
        <p>{ui.coachUnavailable}</p>
        <button className="bbg-btn bbg-btn-primary" onClick={onClose}>{ui.gotIt}</button>
      </div>
    </div>
  ) : null
}
